export enum CertificateTableColumn {
  NOMBRE = 'Nombre',
  DESCRIPCION = 'Descripcion',
  COSTO = 'Costo',
  APROBACION = 'Aprobacion',
  STATUS = 'Estatus',
  SOLICITUDES = 'Solicitudes',
}
